import _ from 'lodash';

import { State } from '../../../types';
import { WaiverWorkItemResolutionsState } from './waiverWorkItemResolutionsReducer';
import { Resolution } from '../../../../types/waiverWorkItem';

function selectRoot(state: State): WaiverWorkItemResolutionsState {
  return state.entities.waivers.workItemResolutions;
}

export const selectErrorMessage = (state: State): string | null =>
  selectRoot(state).error ?? null;

export const selectResolutions = (state: State): Resolution[] | null =>
  _.sortBy(selectRoot(state).entities);
